import { asyncHandler } from '../async-handler';
import store from '../../../store/store';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { AI_TRACKER_BASIC_CONFIGS_API } from '../../constants/central-api';
import { applicationWWWXRLEncodedBodyBuilder } from '../../utils/body-builder';

export default async function post_ai_tracker_basic_configs_api_call(
  webshopUrl: string,
  cmsType: string,
  optimizationRatio: number,
  enabledTracking: boolean
) {
  const shopSlug = store.getState().user?.company?.shop_slug;
  const accessToken = store.getState().auth.authorization.accessToken;
  const isWhiteLabel = store.getState().UI?.isWhiteLabel;
  let sellerToken: string;
  if (isWhiteLabel) {
    sellerToken = accessToken?.currentWhiteLabelSellerToken;
  } else {
    sellerToken = accessToken?.sellerToken;
  }

  if (!shopSlug) {
    return false;
  }

  const requestInfo: RequestInfo = {
    url: `${AI_TRACKER_BASIC_CONFIGS_API(shopSlug)}`,
    method: 'POST',
    body: applicationWWWXRLEncodedBodyBuilder({
      webshop_url: webshopUrl,
      cms_type: cmsType,
      optimization_ratio: optimizationRatio,
      enabled_tracking: enabledTracking,
    }),
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/x-www-form-urlencoded',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
  };

  const actionType = 'POST_AI_TRACKER_BASIC_CONFIGS';
  const customMsg = '';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false
  );

  const response = res?.data;
  return response;
}
